<template>
  <div>
    <ReportPageV2 v-if="canUseReportSlidesPreview" />
    <ReportPage v-else />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import ReportPage from '@/components-v2/presentation-report/ReportPage.vue'
import ReportPageV2 from '@/components-v2/presentation-report/ReportPageV2.vue'

export default {
  components: {
    ReportPage,
    ReportPageV2,
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseReportSlidesPreview']),
  },
}
</script>
